if($('.breadcrumbs span#navigation-1 span[itemprop="name"]').text() ==='Nákupní rádce'){
    $('body').addClass('type-nakupniRadce');
    function initIframeResize() {
        if (typeof iFrameResize === 'undefined') {

        } else {
            startResize();
        }

        function startResize() {
            iFrameResize({
                log: false,
                checkOrigin: false
            }, '#loadbeeIframeId');
        }
    }

    document.addEventListener("DOMContentLoaded", initIframeResize);
}